"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonMenu_1 = __importDefault(require("./ButtonMenu"));
var remote_1 = __importDefault(require("./remote"));
var ButtonMenuRemote = remote_1.default(ButtonMenu_1.default);
exports.default = ButtonMenuRemote;
//# sourceMappingURL=ButtonMenuRemote.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ButtonMenuRemote.js
// module id = 950
// module chunks = 0